export const translations = {
  en: {
    nav: {
      home: 'Home',
      solutions: 'Solutions',
      industries: 'Industries',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      title: 'Transform Your Business with LAIMU Trantor',
      subtitle: 'Comprehensive management platform for',
      description: 'Streamline operations, boost productivity, and drive growth with our integrated business management solution.',
      trustedBy: 'Trusted by leading companies'
    },
    benefits: {
      title: 'Why Choose LAIMU Trantor?',
      subtitle: 'Discover the powerful advantages that make LAIMU Trantor the preferred choice for modern businesses seeking operational excellence and sustainable growth.',
      items: {
        efficiency: {
          title: 'Operational Efficiency',
          description: 'Streamline your business processes and eliminate redundancies with our integrated platform that connects all departments seamlessly.',
          metrics: {
            value: '40%',
            label: 'Efficiency Increase'
          }
        },
        growth: {
          title: 'Accelerated Growth',
          description: 'Scale your business faster with data-driven insights and automated workflows that adapt to your growing needs.',
          metrics: {
            value: '65%',
            label: 'Faster Growth'
          }
        },
        data: {
          title: 'Data-Driven Decisions',
          description: 'Make informed decisions with real-time analytics and comprehensive reporting across all business functions.',
          metrics: {
            value: '90%',
            label: 'Better Decisions'
          }
        },
        speed: {
          title: 'Lightning Fast',
          description: 'Experience blazing-fast performance with our cloud-native architecture designed for modern business demands.',
          metrics: {
            value: '3x',
            label: 'Faster Processing'
          }
        },
        security: {
          title: 'Enterprise Security',
          description: 'Protect your business data with bank-level security, compliance standards, and 99.9% uptime guarantee.',
          metrics: {
            value: '99.9%',
            label: 'Uptime Guarantee'
          }
        },
        collaboration: {
          title: 'Team Collaboration',
          description: 'Enhance team productivity with integrated communication tools and shared workspaces across all modules.',
          metrics: {
            value: '50%',
            label: 'Better Collaboration'
          }
        }
      },
      caseStudy: {
        title: 'AutoMex Transforms Operations',
        description: 'See how AutoMex, a leading automotive manufacturer, revolutionized their operations with LAIMU Trantor, achieving remarkable results in just 6 months.',
        results: [
          'Cost Reduction',
          'Process Efficiency',
          'Revenue Growth',
          'Implementation Time'
        ]
      }
    },
    solutions: {
      title: 'Comprehensive Business Solutions',
      subtitle: 'Integrated modules designed to transform every aspect of your business operations.',
      modulesTitle: 'Our Modules',
      modulesSubtitle: 'Click to explore each solution',
      modules: {
        crm: {
          title: 'Commercial',
          fullTitle: 'Customer Relationship Management',
          shortDescription: 'Manage customer relationships and sales',
          description: 'Streamline your sales process, manage customer relationships, and boost revenue with our comprehensive Commercial module.',
          features: [
            'Lead and opportunity management',
            'Customer database and segmentation',
            'Sales pipeline tracking',
            'Quote and proposal generation',
            'Sales performance analytics',
            'Mobile sales app'
          ],
          imageSrc: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        erp: {
          title: 'Business Management',
          fullTitle: 'Enterprise Resource Planning',
          shortDescription: 'Complete business resource management',
          description: 'Integrate all your business processes with our comprehensive Business Management system for maximum efficiency and control. Full compliance with SAT requirements, CFDI 4.0 invoicing, and Electronic Accounting for the Mexican market.',
          features: [
            'Financial management and accounting',
            'Full SAT compliance & CFDI 4.0 invoicing',
            'Certified Electronic Accounting',
            'Inventory and warehouse management',
            'Multi-company & multi-currency support',
            'Real-time financial reporting'
          ],
          imageSrc: 'https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        tms: {
          title: 'Transport & Logistics',
          fullTitle: 'Transportation Management System',
          shortDescription: 'Optimize logistics and transportation',
          description: 'Optimize your logistics operations with our advanced Transport & Logistics module for efficient delivery and cost reduction. Includes automatic generation of Carta Porte Complement for full compliance with Mexican transportation regulations.',
          features: [
            'Automated Carta Porte Complement generation',
            'Route optimization and planning',
            'Fleet tracking and management',
            'GPS integration and real-time tracking',
            'Freight cost optimization',
            'Performance analytics and reporting'
          ],
          imageSrc: 'https://images.pexels.com/photos/6169668/pexels-photo-6169668.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        mrp: {
          title: 'Production & Inventory',
          fullTitle: 'Manufacturing Resource Planning',
          shortDescription: 'Manufacturing and inventory control',
          description: 'Streamline your manufacturing processes and inventory management with our comprehensive Production & Inventory module.',
          features: [
            'Material requirements planning (MRP)',
            'Production order control & scheduling',
            'Bill of materials (BOM) management',
            'Production cost tracking & audits',
            'Quality control and inspections',
            'Real-time factory inventory control'
          ],
          imageSrc: 'https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        hrms: {
          title: 'Talent Management',
          fullTitle: 'Human Resource Management System',
          shortDescription: 'Complete human resource management',
          description: 'Manage your workforce effectively with our comprehensive Talent Management system for optimal human resource utilization.',
          features: [
            'Employee portal and self-service',
            'Payroll processing & time tracking',
            'Performance and talent management',
            'Recruitment and onboarding',
            'HR analytics and reporting',
            'NOM-035 compliance and surveys'
          ],
          imageSrc: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        kpis: {
          title: 'KPIs',
          fullTitle: 'Key Performance Indicators Dashboard',
          shortDescription: 'Business intelligence and analytics',
          description: 'Monitor your business performance with real-time KPIs and comprehensive analytics for data-driven decision making.',
          features: [
            'Real-time dashboard and reporting',
            'Custom KPI configuration',
            'Business intelligence analytics',
            'Trend analysis and forecasting',
            'Executive reporting automated',
            'Mobile access & data visualization'
          ],
          imageSrc: 'https://images.pexels.com/photos/6801874/pexels-photo-6801874.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        }
      }
    },
    industries: {
      automotive: {
        title: 'Automotive',
        description: 'Specialized solutions for automotive manufacturers and suppliers, optimizing production lines, quality control, and supply chain management.',
        painPoints: [
          {
            title: 'Complex Supply Chain',
            description: 'Managing multiple suppliers and ensuring just-in-time delivery while maintaining quality standards.'
          },
          {
            title: 'Quality Compliance',
            description: 'Meeting strict automotive industry standards and regulatory requirements across all processes.'
          },
          {
            title: 'Production Efficiency',
            description: 'Optimizing manufacturing processes to reduce waste and improve overall equipment effectiveness.'
          }
        ],
        testimonial: {
          company: 'AutoMex Manufacturing',
          quote: 'LAIMU Trantor helped us reduce production costs by 25% while improving quality metrics.',
          author: 'Carlos Rodriguez',
          role: 'Operations Director'
        },
        imageSrc: 'https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      manufacturing: {
        title: 'Manufacturing',
        description: 'Comprehensive manufacturing solutions for production planning, inventory management, and quality control across diverse manufacturing sectors.',
        painPoints: [
          {
            title: 'Production Planning',
            description: 'Coordinating complex production schedules while optimizing resource utilization and minimizing downtime.'
          },
          {
            title: 'Inventory Management',
            description: 'Balancing inventory levels to meet demand while minimizing carrying costs and waste.'
          },
          {
            title: 'Quality Control',
            description: 'Maintaining consistent product quality while meeting production targets and deadlines.'
          }
        ],
        testimonial: {
          company: 'TechManufactura',
          quote: 'Our production efficiency increased by 40% after implementing LAIMU Trantor.',
          author: 'Ana Martinez',
          role: 'Production Manager'
        },
        imageSrc: 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      accounting: {
        title: 'Accounting & Tax',
        description: 'Specialized solutions for accounting firms and tax consultancies, streamlining financial processes, compliance, and client management.',
        painPoints: [
          {
            title: 'Tax Compliance',
            description: 'Managing complex tax regulations and ensuring accurate, timely filing for multiple clients across different jurisdictions.'
          },
          {
            title: 'Client Management',
            description: 'Organizing client data, deadlines, and communications while maintaining confidentiality and security.'
          },
          {
            title: 'Financial Reporting',
            description: 'Generating accurate financial reports and statements while ensuring compliance with accounting standards.'
          }
        ],
        testimonial: {
          company: 'Contadores Asociados',
          quote: 'LAIMU Trantor streamlined our tax processes and improved client satisfaction by 35%.',
          author: 'Miguel Santos',
          role: 'Managing Partner'
        },
        imageSrc: 'https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      logistics: {
        title: 'Logistics & Distribution',
        description: 'Advanced logistics solutions for transportation companies and distribution centers, optimizing routes, fleet management, and delivery operations.',
        painPoints: [
          {
            title: 'Route Optimization',
            description: 'Planning efficient delivery routes while considering traffic, fuel costs, and customer time windows.'
          },
          {
            title: 'Fleet Management',
            description: 'Monitoring vehicle performance, maintenance schedules, and driver productivity across the entire fleet.'
          },
          {
            title: 'Real-time Tracking',
            description: 'Providing customers with accurate delivery updates while maintaining operational visibility.'
          }
        ],
        testimonial: {
          company: 'LogiMex Express',
          quote: 'We reduced delivery times by 30% and fuel costs by 20% with LAIMU Trantor.',
          author: 'Sofia Hernandez',
          role: 'Logistics Director'
        },
        imageSrc: 'https://images.pexels.com/photos/6169668/pexels-photo-6169668.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      printing: {
        title: 'Printing & Packaging',
        description: 'Tailored solutions for printing and packaging companies, managing complex orders, production workflows, and quality standards.',
        painPoints: [
          {
            title: 'Order Complexity',
            description: 'Managing diverse printing jobs with varying specifications, quantities, and delivery requirements.'
          },
          {
            title: 'Production Workflow',
            description: 'Coordinating pre-press, printing, and finishing operations while maintaining quality and deadlines.'
          },
          {
            title: 'Material Management',
            description: 'Tracking paper, ink, and other materials while optimizing inventory and reducing waste.'
          }
        ],
        testimonial: {
          company: 'Imprenta Digital Plus',
          quote: 'Our order processing time decreased by 50% and customer satisfaction improved significantly.',
          author: 'Roberto Jimenez',
          role: 'Production Manager'
        },
        imageSrc: 'https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      }
    },
    industriesSection: {
      title: 'Industries We Serve',
      subtitle: 'Specialized solutions tailored to the unique needs of your industry.',
      successStory: 'Success Story'
    },
    useCases: {
      title: 'Problems We Solve',
      subtitle: 'Real business challenges transformed into operational advantages with Laimu.',
      cases: [
        {
          icon: 'inventory',
          challenge: 'Outdated Inventories',
          challengeDescription: 'Manual tracking leads to stock discrepancies, excess inventory, and lost sales opportunities due to out-of-stock situations.',
          solution: 'Real-Time Control with Laimu',
          solutionDescription: 'Automated inventory tracking with real-time visibility across all locations, intelligent reorder points, and predictive analytics.',
          impact: '87%',
          impactLabel: 'Reduction in Stock Discrepancies'
        },
        {
          icon: 'automation',
          challenge: 'Slow Manual Processes',
          challengeDescription: 'Time-consuming manual data entry, duplicate work across departments, and human errors that delay operations and increase costs.',
          solution: 'Intelligent Workflow Automation',
          solutionDescription: 'End-to-end process automation with smart integrations, automated approvals, and seamless data flow between all departments.',
          impact: '65%',
          impactLabel: 'Time Saved on Operations'
        },
        {
          icon: 'visibility',
          challenge: 'Lack of Operational Visibility',
          challengeDescription: 'Scattered data across multiple systems makes it impossible to get a clear picture of business performance in real-time.',
          solution: 'Unified Dashboard with Real-Time KPIs',
          solutionDescription: 'Centralized command center with live metrics, customizable dashboards, and actionable insights for faster decision-making.',
          impact: '3x',
          impactLabel: 'Faster Decision Making'
        }
      ]
    },
    testimonials: {
      title: 'What Our Clients Say',
      subtitle: 'Real stories from companies that have transformed their operations with LAIMU Trantor.',
      items: [
        {
          quote: 'LAIMU Trantor transformed our operations completely. We saw a 45% increase in efficiency within the first 6 months.',
          name: 'Maria González',
          role: 'Operations Director',
          company: 'AutoMex',
          rating: 5,
          metrics: [
            { value: '45%', label: 'Efficiency Increase' },
            { value: '6 months', label: 'ROI Timeline' },
            { value: '25%', label: 'Cost Reduction' }
          ]
        },
        {
          quote: 'The integrated platform eliminated our data silos and improved decision-making across all departments.',
          name: 'Carlos Mendoza',
          role: 'CEO',
          company: 'TechManufactura',
          rating: 5,
          metrics: [
            { value: '80%', label: 'Data Accuracy' },
            { value: '60%', label: 'Faster Reporting' },
            { value: '35%', label: 'Better Decisions' }
          ]
        },
        {
          quote: 'Outstanding support and a platform that grows with our business. Highly recommended for any manufacturing company.',
          name: 'Ana Rodriguez',
          role: 'Plant Manager',
          company: 'Industrias del Norte',
          rating: 5,
          metrics: [
            { value: '99.9%', label: 'System Uptime' },
            { value: '24/7', label: 'Support Available' },
            { value: '300%', label: 'Scalability' }
          ]
        }
      ]
    },
    contact: {
      title: 'Get Started Today',
      subtitle: 'Ready to transform your business? Contact our experts for a personalized consultation.',
      office: 'Our Office',
      phone: 'Phone',
      email: 'Email',
      scheduleDemo: 'Schedule a Demo',
      scheduleDemoText: 'Book a personalized demonstration',
      scheduleButton: 'Book Demo',
      address: {
        line1: 'Pedro Noriega 1751',
        line2: 'Col. Terminal',
        city: 'Monterrey',
        state: 'NL',
        zip: '64580'
      },
      formTitle: 'Send us a message',
      form: {
        name: 'Full Name',
        namePlaceholder: 'Your full name',
        email: 'Email Address',
        emailPlaceholder: 'your@email.com',
        company: 'Company',
        companyPlaceholder: 'Your company name',
        industry: 'Industry',
        industryPlaceholder: 'Select your industry',
        message: 'Message',
        messagePlaceholder: 'Tell us about your needs...',
        submit: 'Send Message',
        other: 'Other'
      }
    },
    footer: {
      description: 'Transform your business with our comprehensive management platform. Trusted by 500+ companies across Mexico and Latin America.',
      solutions: 'Solutions',
      industries: 'Industries',
      company: 'Company',
      address: 'Pedro Noriega 1751, Col. Terminal, 64580, Monterrey, Nuevo León, Mexico',
      links: [
        { text: 'About Us', href: '/about' },
        { text: 'Success Cases', href: '/success-cases' },
        { text: 'Blog', href: '/blog' },
        { text: 'Support', href: '/demo' }
      ],
      rights: 'All rights reserved.',
      privacy: 'Privacy Notice',
      terms: 'Terms and Conditions',
      cookies: 'Cookie Policy'
    },
    cta: {
      demo: 'Request Demo',
      learnMore: 'Learn More',
      contact: 'Contact Sales',
      industryDemo: 'See Industry Demo',
      caseStudy: 'View Case Studies'
    },
    blog: {
      navLabel: 'Blog',
      heroTitle: 'Insights & Resources',
      heroSubtitle: 'Expert articles on ERP, CFDI, manufacturing, logistics, and digital transformation in Mexico.',
      featuredLabel: 'Featured Article',
      readMore: 'Read More',
      minutesRead: 'min read',
      allCategories: 'All',
      searchPlaceholder: 'Search articles...',
      noResults: 'No articles found. Try a different search or category.',
      backToBlog: 'Back to Blog',
      shareArticle: 'Share this article',
      relatedPosts: 'Related Articles',
      tableOfContents: 'Table of Contents',
      requestDemoCta: 'Request a Free Demo',
      requestDemoText: 'See how LAIMU Trantor can transform your business. Schedule a personalized demo at no cost.',
      newsletterTitle: 'Subscribe to Our Newsletter',
      newsletterSubtitle: 'Get the latest articles on business management, technology, and compliance in Mexico.',
      newsletterPlaceholder: 'Enter your email',
      newsletterButton: 'Subscribe',
      newsletterSuccess: 'Thank you for subscribing!',
      newsletterError: 'Something went wrong. Please try again.',
      newsletterDuplicate: 'This email is already subscribed.',
      newsletterPrivacy: 'I agree to receive communications from LAIMU.',
      latestInsights: 'Latest Insights',
      viewAllPosts: 'View All Articles',
      publishedOn: 'Published on',
      by: 'by',
      loadingPosts: 'Loading articles...',
      loadMore: 'Load More',
      category: 'Category',
      tags: 'Tags'
    },
    successCases: {
      title: 'Success Stories That Inspire',
      subtitle: 'Discover how companies across different industries have transformed their operations and achieved remarkable results with LAIMU Trantor.',
      cases: [
        {
          id: 'automex',
          company: 'AutoMex Manufacturing',
          industry: 'Automotive',
          employees: '500+ employees',
          timeline: '6 months implementation',
          challenge: 'AutoMex was struggling with disconnected systems, manual processes, and lack of real-time visibility across their manufacturing operations. Quality control issues and supply chain inefficiencies were impacting their ability to meet customer demands.',
          solution: 'Implemented a comprehensive LAIMU Trantor solution including Business Management, Production & Inventory, and Commercial modules. The integrated platform provided real-time visibility and automated key processes.',
          modules: ['Business Management', 'Production & Inventory', 'Commercial', 'KPIs'],
          results: [
            '45% reduction in production costs',
            '80% improvement in on-time delivery',
            '60% faster order processing',
            '300% increase in data accuracy',
            '25% reduction in inventory holding costs'
          ],
          testimonial: {
            quote: 'LAIMU Trantor transformed our entire operation. The real-time visibility and integrated processes have made us more competitive than ever.',
            author: 'Carlos Rodriguez',
            role: 'Operations Director'
          },
          imageSrc: 'https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        {
          id: 'logimex',
          company: 'LogiMex Express',
          industry: 'Logistics & Distribution',
          employees: '200+ employees',
          timeline: '4 months implementation',
          challenge: 'LogiMex faced challenges with route optimization, fleet management, and customer communication. Manual planning processes were leading to increased fuel costs and delayed deliveries.',
          solution: 'Deployed LAIMU Trantor\'s Transport & Logistics module along with Commercial and KPIs modules to optimize operations and improve customer service.',
          modules: ['Transport & Logistics', 'Commercial', 'KPIs'],
          results: [
            '30% reduction in delivery times',
            '20% decrease in fuel costs',
            '90% improvement in customer satisfaction',
            '50% faster route planning',
            '40% increase in fleet utilization'
          ],
          testimonial: {
            quote: 'The route optimization and real-time tracking capabilities have revolutionized our logistics operations.',
            author: 'Sofia Hernandez',
            role: 'Logistics Director'
          },
          imageSrc: 'https://images.pexels.com/photos/6169668/pexels-photo-6169668.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        {
          id: 'techmanufactura',
          company: 'TechManufactura',
          industry: 'Manufacturing',
          employees: '300+ employees',
          timeline: '5 months implementation',
          challenge: 'TechManufactura needed to modernize their manufacturing processes, improve quality control, and gain better visibility into their operations to compete in the global market.',
          solution: 'Implemented a full LAIMU Trantor suite including Business Management, Production & Inventory, Talent Management, and KPIs modules for complete operational transformation.',
          modules: ['Business Management', 'Production & Inventory', 'Talent Management', 'KPIs'],
          results: [
            '40% increase in production efficiency',
            '65% reduction in quality defects',
            '35% improvement in employee productivity',
            '50% faster reporting and analytics',
            '28% reduction in operational costs'
          ],
          testimonial: {
            quote: 'LAIMU Trantor gave us the tools to compete globally. Our efficiency and quality improvements have been remarkable.',
            author: 'Ana Martinez',
            role: 'Production Manager'
          },
          imageSrc: 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        }
      ]
    },
    legal: {
      privacy: {
        title: 'Privacy Policy',
        lastUpdated: 'Last updated',
        date: 'January 15, 2024',
        introduction: {
          title: 'Introduction',
          content: 'LAIMU ("we," "us," or "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy will inform you about how we look after your personal data when you visit our website, use our services, or interact with us, and tell you about your privacy rights and how the law protects you. This Privacy Policy applies to all personal data we process about you.'
        },
        scope: {
          title: 'Scope of This Policy',
          content: 'This Privacy Policy applies to personal data collected by LAIMU through our websites, mobile applications, software-as-a-service offerings, and other online and offline interactions with you. It covers data collected directly from you, data we receive from third parties, and data we generate about your use of our services.',
          exclusions: 'This policy does not apply to: (a) data processed by our customers using our services, (b) third-party websites or services linked from our sites, or (c) employment-related data of our employees and contractors.'
        },
        controller: {
          title: 'Data Controller',
          content: 'LAIMU is the data controller for the personal data we process under this Privacy Policy. Our contact details are provided at the end of this policy.'
        },
        dataCollection: {
          title: 'Personal Data We Collect',
          intro: 'We collect different types of personal data about you. This includes data you give us directly, data we collect automatically, and data we receive from third parties.',
          categories: {
            identity: {
              title: 'Identity Data',
              items: ['First name, last name, username, title, date of birth, gender']
            },
            contact: {
              title: 'Contact Data',
              items: ['Email address, telephone numbers, billing address, delivery address']
            },
            financial: {
              title: 'Financial Data',
              items: ['Bank account details, payment card details, transaction history']
            },
            technical: {
              title: 'Technical Data',
              items: ['Internet protocol (IP) address, browser type and version, time zone setting, browser plug-in types, operating system and platform, device information']
            },
            profile: {
              title: 'Profile Data',
              items: ['Username, password, purchases, orders, interests, preferences, feedback, survey responses']
            },
            usage: {
              title: 'Usage Data',
              items: ['Information about how you use our website, products and services, including frequency of use, feature usage, performance data']
            },
            marketing: {
              title: 'Marketing and Communications Data',
              items: ['Your preferences in receiving marketing from us and our third parties, communication preferences']
            }
          },
          sources: {
            title: 'How We Collect Personal Data',
            direct: {
              title: 'Direct Interactions',
              content: 'You may give us your personal data by filling in forms or by corresponding with us by post, phone, email or otherwise. This includes personal data you provide when you:',
              examples: ['Apply for our products or services', 'Create an account on our website', 'Subscribe to our service or publications', 'Request marketing to be sent to you', 'Enter a competition, promotion or survey', 'Give us feedback or contact us']
            },
            automated: {
              title: 'Automated Technologies or Interactions',
              content: 'As you interact with our website, we will automatically collect Technical Data about your equipment, browsing actions and patterns. We collect this personal data by using cookies, server logs and other similar technologies.'
            },
            thirdParties: {
              title: 'Third Parties or Publicly Available Sources',
              content: 'We will receive personal data about you from various third parties and public sources as set out below:',
              sources: ['Technical Data from analytics providers such as Google', 'Contact, Financial and Transaction Data from providers of technical, payment and delivery services', 'Identity and Contact Data from data brokers or aggregators', 'Identity and Contact Data from publicly available sources']
            }
          }
        },
        legalBasis: {
          title: 'Legal Basis for Processing',
          intro: 'We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:',
          bases: {
            consent: {
              title: 'Consent',
              content: 'Where you have given clear consent for us to process your personal data for a specific purpose.'
            },
            contract: {
              title: 'Contract',
              content: 'Where we need to perform the contract we are about to enter into or have entered into with you.'
            },
            legal: {
              title: 'Legal Obligation',
              content: 'Where we need to comply with a legal obligation.'
            },
            vital: {
              title: 'Vital Interests',
              content: 'Where it is needed to protect someone\'s life.'
            },
            public: {
              title: 'Public Task',
              content: 'Where we need to perform a task in the public interest or for our official functions.'
            },
            legitimate: {
              title: 'Legitimate Interests',
              content: 'Where we need to for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.'
            }
          }
        },
        dataUse: {
          title: 'How We Use Your Personal Data',
          intro: 'We have set out below, in a table format, a description of all the ways we plan to use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate.',
          purposes: {
            registration: {
              purpose: 'To register you as a new customer',
              dataTypes: 'Identity, Contact',
              legalBasis: 'Performance of a contract with you'
            },
            services: {
              purpose: 'To process and deliver your order including managing payments, fees and charges, and collecting and recovering money owed to us',
              dataTypes: 'Identity, Contact, Financial, Transaction, Marketing and Communications',
              legalBasis: 'Performance of a contract with you; Necessary for our legitimate interests (to recover debts due to us)'
            },
            relationship: {
              purpose: 'To manage our relationship with you including notifying you about changes to our terms or privacy policy, and asking you to leave a review or take a survey',
              dataTypes: 'Identity, Contact, Profile, Marketing and Communications',
              legalBasis: 'Performance of a contract with you; Necessary to comply with a legal obligation; Necessary for our legitimate interests (to keep our records updated and to study how customers use our products/services)'
            },
            administration: {
              purpose: 'To enable you to partake in a prize draw, competition or complete a survey',
              dataTypes: 'Identity, Contact, Profile, Usage, Marketing and Communications',
              legalBasis: 'Necessary for our legitimate interests (to study how customers use our products/services, to develop them and grow our business)'
            },
            business: {
              purpose: 'To administer and protect our business and this website (including troubleshooting, data analysis, testing, system maintenance, support, reporting and hosting of data)',
              dataTypes: 'Identity, Contact, Technical',
              legalBasis: 'Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security, to prevent fraud and in the context of a business reorganisation or group restructuring exercise); Necessary to comply with a legal obligation'
            },
            content: {
              purpose: 'To deliver relevant website content and advertisements to you and measure or understand the effectiveness of the advertising we serve to you',
              dataTypes: 'Identity, Contact, Profile, Usage, Marketing and Communications, Technical',
              legalBasis: 'Necessary for our legitimate interests (to study how customers use our products/services, to develop them, to grow our business and to inform our marketing strategy)'
            },
            analytics: {
              purpose: 'To use data analytics to improve our website, products/services, marketing, customer relationships and experiences',
              dataTypes: 'Technical, Usage',
              legalBasis: 'Necessary for our legitimate interests (to define types of customers for our products and services, to keep our website updated and relevant, to develop our business and to inform our marketing strategy)'
            },
            recommendations: {
              purpose: 'To make suggestions and recommendations to you about goods or services that may be of interest to you',
              dataTypes: 'Identity, Contact, Technical, Usage, Profile, Marketing and Communications',
              legalBasis: 'Necessary for our legitimate interests (to develop our products/services and grow our business)'
            }
          },
          marketing: {
            title: 'Marketing',
            content: 'We strive to provide you with choices regarding certain personal data uses, particularly around marketing and advertising. You can view and make certain decisions about your personal data use in your account settings.'
          }
        },
        sharing: {
          title: 'Disclosures of Your Personal Data',
          intro: 'We may have to share your personal data with the parties set out below for the purposes set out in the table above.',
          categories: {
            internal: {
              title: 'Internal Third Parties',
              content: 'Other companies in the LAIMU Group acting as joint controllers or processors and who are based in Mexico and provide IT and system administration services and undertake leadership reporting.'
            },
            external: {
              title: 'External Third Parties',
              items: [
                'Service providers acting as processors who provide IT and system administration services',
                'Professional advisers acting as processors or joint controllers including lawyers, bankers, auditors and insurers who provide consultancy, banking, legal, insurance and accounting services',
                'Tax authorities, regulators and other authorities acting as processors or joint controllers based in Mexico who require reporting of processing activities in certain circumstances'
              ]
            },
            specific: {
              title: 'Specific Third Parties',
              items: [
                'Analytics providers such as Google Analytics',
                'Advertising networks and social media platforms',
                'Payment processors and financial institutions',
                'Customer support and communication platforms',
                'Cloud hosting and infrastructure providers',
                'Security and fraud prevention services'
              ]
            }
          },
          circumstances: {
            title: 'We may also share your personal data in the following circumstances:',
            items: [
              'Business transfers: In connection with any merger, sale of assets, financing, or acquisition of all or a portion of our business',
              'Legal requirements: When required by law, regulation, legal process, or governmental request',
              'Safety and security: To protect the rights, property, or safety of LAIMU, our users, or others',
              'Consent: When you have given us explicit consent to share your information',
              'Public information: Information that you make publicly available',
              'Aggregated data: De-identified or aggregated information that cannot reasonably identify you'
            ]
          }
        },
        internationalTransfers: {
          title: 'International Transfers',
          content: 'We may transfer your personal data outside of Mexico. Whenever we transfer your personal data out of Mexico, we ensure a similar degree of protection is afforded to it by ensuring at least one of the following safeguards is implemented:',
          safeguards: [
            'We will only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data',
            'Where we use certain service providers, we may use specific contracts approved by regulatory authorities which give personal data the same protection it has in Mexico',
            'Where we use providers based in the US, we may transfer data to them if they are part of the Privacy Shield which requires them to provide similar protection to personal data shared between Mexico and the US'
          ]
        },
        dataSecurity: {
          title: 'Data Security',
          content: 'We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.',
          measures: [
            'Industry-standard encryption for data in transit and at rest',
            'Multi-factor authentication for system access',
            'Regular security audits and penetration testing',
            'Employee training on data protection and security',
            'Incident response procedures for data breaches',
            'Physical security controls for our facilities',
            'Network security monitoring and intrusion detection',
            'Regular software updates and security patches',
            'Data backup and disaster recovery procedures'
          ],
          breach: 'We have procedures in place to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.'
        },
        retention: {
          title: 'Data Retention',
          intro: 'We will only retain your personal data for as long as reasonably necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting or reporting requirements.',
          criteria: 'To determine the appropriate retention period for personal data, we consider the amount, nature and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory, tax, accounting or other requirements.',
          periods: {
            account: {
              type: 'Account Data',
              period: 'For the duration of your account plus 7 years after account closure'
            },
            transaction: {
              type: 'Transaction Records',
              period: '10 years from the date of transaction for tax and accounting purposes'
            },
            communication: {
              type: 'Communication Data',
              period: '3 years from last communication for customer service purposes'
            },
            usage: {
              type: 'Usage and Analytics Data',
              period: '2 years from collection for business improvement purposes'
            },
            marketing: {
              type: 'Marketing Data',
              period: 'Until you withdraw consent or opt-out of marketing communications'
            }
          }
        },
        rights: {
          title: 'Your Legal Rights',
          intro: 'Under certain circumstances, you have rights under data protection laws in relation to your personal data. You have the right to:',
          list: {
            access: {
              title: 'Request access',
              description: 'to your personal data (commonly known as a "data subject access request"). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it.'
            },
            correction: {
              title: 'Request correction',
              description: 'of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us.'
            },
            erasure: {
              title: 'Request erasure',
              description: 'of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing, where we may have processed your information unlawfully or where we are required to erase your personal data to comply with local law.'
            },
            objection: {
              title: 'Object to processing',
              description: 'of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes.'
            },
            restriction: {
              title: 'Request restriction',
              description: 'of processing of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: if you want us to establish the data\'s accuracy; where our use of the data is unlawful but you do not want us to erase it; where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims; or you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it.'
            },
            portability: {
              title: 'Request transfer',
              description: 'of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you.'
            },
            withdraw: {
              title: 'Withdraw consent',
              description: 'at any time where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent.'
            }
          },
          exercise: {
            title: 'How to Exercise Your Rights',
            content: 'If you wish to exercise any of the rights set out above, please contact us using the details provided at the end of this policy. You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we could refuse to comply with your request in these circumstances.',
            verification: 'We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.',
            timeframe: 'We try to respond to all legitimate requests within one month. Occasionally it could take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.'
          }
        },
        minors: {
          title: 'Children\'s Privacy',
          content: 'Our services are not intended for children under 16 years of age. We do not knowingly collect personal data from children under 16. If you are under 16, do not use or provide any information on our website or through our services. If we learn we have collected or received personal data from a child under 16 without verification of parental consent, we will delete that information. If you believe we might have any information from or about a child under 16, please contact us.'
        },
        thirdPartyLinks: {
          title: 'Third-Party Links',
          content: 'This website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy policy of every website you visit.'
        },
        updates: {
          title: 'Changes to This Privacy Policy',
          content: 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "last updated" date. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.',
          notification: 'If we make material changes to how we treat our users\' personal data, we will notify you through a notice on the website home page or by email to the primary email address specified in your account.'
        },
        complaints: {
          title: 'Complaints',
          content: 'You have the right to make a complaint at any time to the relevant supervisory authority for data protection issues. We would, however, appreciate the chance to deal with your concerns before you approach the supervisory authority so please contact us in the first instance.',
          authorities: {
            mexico: 'Mexico: National Institute for Transparency, Access to Information and Personal Data Protection (INAI)',
            eu: 'EU: Your local data protection authority',
            us: 'US: Federal Trade Commission (FTC) or your state attorney general'
          }
        },
        contact: {
          title: 'Contact Information',
          content: 'If you have any questions about this Privacy Policy or our privacy practices, please contact us using the information below:',
          details: {
            company: 'LAIMU',
            dpo: 'Data Protection Officer',
            email: 'privacy@laimu.mx',
            phone: '+52 81 1107 1450',
            address: 'Pedro Noriega 1751, Monterrey, NL 64580, Mexico',
            hours: 'Monday to Friday, 9:00 AM to 6:00 PM (CST)'
          },
          response: 'We will respond to your inquiry within 30 days of receipt. For urgent privacy matters, please call our main number and ask to speak with our Data Protection Officer.'
        }
      },
      terms: {
        title: 'Terms of Service',
        lastUpdated: 'Last updated',
        date: 'January 15, 2024',
        acceptance: {
          title: 'Acceptance of Terms',
          content: 'By accessing and using LAIMU Trantor services, you accept and agree to be bound by the terms and provision of this agreement.'
        },
        services: {
          title: 'Description of Services',
          intro: 'LAIMU provides business management software solutions including:',
          list: [
            'Enterprise Resource Planning (ERP) systems',
            'Customer Relationship Management (CRM) tools',
            'Transportation Management Systems (TMS)',
            'Manufacturing Resource Planning (MRP) solutions',
            'Human Resource Management Systems (HRMS)',
            'Key Performance Indicators (KPI) dashboards'
          ]
        },
        userResponsibilities: {
          title: 'User Responsibilities',
          intro: 'As a user of our services, you agree to:',
          list: [
            'Provide accurate and complete information',
            'Maintain the security of your account credentials',
            'Use the services in compliance with applicable laws',
            'Not attempt to breach system security',
            'Respect intellectual property rights'
          ]
        },
        payment: {
          title: 'Payment Terms',
          content: 'Payment terms are specified in your service agreement. All fees are non-refundable unless otherwise stated. We reserve the right to modify pricing with appropriate notice.'
        },
        liability: {
          title: 'Limitation of Liability',
          content: 'LAIMU shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services, except as required by applicable law.'
        },
        termination: {
          title: 'Termination',
          content: 'Either party may terminate the service agreement with appropriate notice as specified in your contract. Upon termination, access to the services will be discontinued.'
        },
        changes: {
          title: 'Changes to Terms',
          content: 'We reserve the right to modify these terms at any time. Users will be notified of significant changes, and continued use constitutes acceptance of the modified terms.'
        },
        contact: {
          title: 'Contact Information',
          content: 'For questions about these Terms of Service, please contact us:'
        }
      },
      cookies: {
        title: 'Cookie Policy',
        lastUpdated: 'Last updated',
        date: 'January 15, 2024',
        what: {
          title: 'What Are Cookies',
          content: 'Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and analyzing how you use our site.'
        },
        types: {
          title: 'Types of Cookies We Use',
          intro: 'We use different types of cookies for various purposes:',
          essential: {
            title: 'Essential Cookies',
            description: 'These cookies are necessary for the website to function properly and cannot be disabled.'
          },
          analytics: {
            title: 'Analytics Cookies',
            description: 'These cookies help us understand how visitors interact with our website by collecting anonymous information.'
          },
          functional: {
            title: 'Functional Cookies',
            description: 'These cookies enable enhanced functionality and personalization, such as language preferences.'
          },
          marketing: {
            title: 'Marketing Cookies',
            description: 'These cookies are used to deliver relevant advertisements and track the effectiveness of our marketing campaigns.'
          }
        },
        thirdParty: {
          title: 'Third-Party Cookies',
          intro: 'We may use third-party services that set cookies on our behalf:',
          services: [
            'Google Analytics for website analytics',
            'Social media platforms for content sharing',
            'Customer support chat services',
            'Marketing and advertising platforms'
          ]
        },
        control: {
          title: 'Managing Cookies',
          intro: 'You can control cookies through:',
          methods: [
            'Browser settings to block or delete cookies',
            'Our cookie preference center',
            'Third-party opt-out tools',
            'Privacy settings on your device'
          ],
          warning: {
            title: 'Important Note',
            content: 'Disabling certain cookies may affect the functionality of our website and your user experience.'
          }
        },
        updates: {
          title: 'Updates to This Policy',
          content: 'We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.'
        },
        contact: {
          title: 'Contact Us',
          content: 'If you have any questions about our use of cookies, please contact us:'
        }
      }
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      solutions: 'Soluciones',
      industries: 'Industrias',
      about: 'Nosotros',
      contact: 'Contacto'
    },
    hero: {
      title: 'Transforma Tu Negocio con LAIMU Trantor',
      subtitle: 'Plataforma integral de gestión para',
      description: 'Optimiza operaciones, aumenta productividad e impulsa el crecimiento con nuestra solución integrada de gestión empresarial.',
      trustedBy: 'Confiado por empresas líderes'
    },
    benefits: {
      title: '¿Por Qué Elegir LAIMU Trantor?',
      subtitle: 'Descubre las poderosas ventajas que hacen de LAIMU Trantor la opción preferida para empresas modernas que buscan excelencia operacional y crecimiento sostenible.',
      items: {
        efficiency: {
          title: 'Eficiencia Operacional',
          description: 'Optimiza tus procesos empresariales y elimina redundancias con nuestra plataforma integrada que conecta todos los departamentos sin problemas.',
          metrics: {
            value: '40%',
            label: 'Aumento de Eficiencia'
          }
        },
        growth: {
          title: 'Crecimiento Acelerado',
          description: 'Escala tu negocio más rápido con insights basados en datos y flujos de trabajo automatizados que se adaptan a tus necesidades crecientes.',
          metrics: {
            value: '65%',
            label: 'Crecimiento Más Rápido'
          }
        },
        data: {
          title: 'Decisiones Basadas en Datos',
          description: 'Toma decisiones informadas con análisis en tiempo real y reportes comprensivos en todas las funciones empresariales.',
          metrics: {
            value: '90%',
            label: 'Mejores Decisiones'
          }
        },
        speed: {
          title: 'Velocidad Extrema',
          description: 'Experimenta un rendimiento ultrarrápido con nuestra arquitectura nativa en la nube diseñada para las demandas empresariales modernas.',
          metrics: {
            value: '3x',
            label: 'Procesamiento Más Rápido'
          }
        },
        security: {
          title: 'Seguridad Empresarial',
          description: 'Protege los datos de tu negocio con seguridad de nivel bancario, estándares de cumplimiento y garantía de 99.9% de tiempo activo.',
          metrics: {
            value: '99.9%',
            label: 'Garantía de Tiempo Activo'
          }
        },
        collaboration: {
          title: 'Colaboración en Equipo',
          description: 'Mejora la productividad del equipo con herramientas de comunicación integradas y espacios de trabajo compartidos en todos los módulos.',
          metrics: {
            value: '50%',
            label: 'Mejor Colaboración'
          }
        }
      },
      caseStudy: {
        title: 'AutoMex Transforma sus Operaciones',
        description: 'Ve cómo AutoMex, un fabricante automotriz líder, revolucionó sus operaciones con LAIMU Trantor, logrando resultados notables en solo 6 meses.',
        results: [
          'Reducción de Costos',
          'Eficiencia de Procesos',
          'Crecimiento de Ingresos',
          'Tiempo de Implementación'
        ]
      }
    },
    solutions: {
      title: 'Soluciones Empresariales Integrales',
      subtitle: 'Módulos integrados diseñados para transformar cada aspecto de las operaciones de tu negocio.',
      modulesTitle: 'Nuestros Módulos',
      modulesSubtitle: 'Haz clic para explorar cada solución',
      modules: {
        crm: {
          title: 'Comercial',
          fullTitle: 'Gestión de Relaciones con Clientes',
          shortDescription: 'Gestiona relaciones con clientes y ventas',
          description: 'Optimiza tu proceso de ventas, gestiona relaciones con clientes e impulsa los ingresos con nuestro módulo Comercial integral.',
          features: [
            'Gestión de leads y oportunidades',
            'Base de datos y segmentación de clientes',
            'Seguimiento de pipeline de ventas',
            'Generación de cotizaciones y propuestas',
            'Análisis de rendimiento de ventas',
            'App móvil de ventas'
          ],
          imageSrc: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        erp: {
          title: 'Gestión de Empresas',
          fullTitle: 'Planificación de Recursos Empresariales',
          shortDescription: 'Gestión completa de recursos empresariales',
          description: 'Integra todos tus procesos empresariales con nuestro sistema integral de Gestión de Empresas para máxima eficiencia y control. Cumplimiento total con el SAT, Facturación CFDI 4.0 y Contabilidad Electrónica para el mercado mexicano.',
          features: [
            'Gestión financiera y contabilidad',
            'Facturación CFDI 4.0 y Cumplimiento SAT',
            'Contabilidad Electrónica certificada',
            'Gestión de inventario y almacén',
            'Soporte multi-empresa y multi-moneda',
            'Reportes financieros en tiempo real'
          ],
          imageSrc: 'https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        tms: {
          title: 'Transporte y Logística',
          fullTitle: 'Sistema de Gestión de Transporte',
          shortDescription: 'Optimiza logística y transporte',
          description: 'Optimiza tus operaciones logísticas con nuestro módulo avanzado de Transporte y Logística para entregas eficientes y reducción de costos. Incluye generación automática de Complemento Carta Porte para cumplimiento total con la normativa mexicana de transporte.',
          features: [
            'Complemento Carta Porte Automatizado',
            'Optimización y planificación de rutas',
            'Gestión y seguimiento de flota',
            'Integración GPS en tiempo real',
            'Optimización de costos de flete',
            'Análisis de rendimiento y reportes'
          ],
          imageSrc: 'https://images.pexels.com/photos/6169668/pexels-photo-6169668.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        mrp: {
          title: 'Producción e Inventarios',
          fullTitle: 'Planificación de Recursos de Manufactura',
          shortDescription: 'Control de manufactura e inventarios',
          description: 'Optimiza tus procesos de manufactura y gestión de inventarios con nuestro módulo integral de Producción e Inventarios.',
          features: [
            'Planificación de Materiales (MRP)',
            'Control de órdenes de producción',
            'Gestión de lista de materiales (BOM)',
            'Seguimiento de costos de fabricación',
            'Control de calidad e inspecciones',
            'Inventario en tiempo real para planta'
          ],
          imageSrc: 'https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        hrms: {
          title: 'Gestión del Talento',
          fullTitle: 'Sistema de Gestión de Recursos Humanos',
          shortDescription: 'Gestión completa de recursos humanos',
          description: 'Gestiona tu fuerza laboral efectivamente con nuestro sistema integral de Gestión del Talento para una utilización óptima de recursos humanos.',
          features: [
            'Portal del empleado y autoservicio',
            'Nómina y control de asistencia',
            'Gestión de desempeño y talento',
            'Reclutamiento e incorporación',
            'Análisis y reportes de RH',
            'Cumplimiento NOM-035 y Clima Laboral'
          ],
          imageSrc: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        kpis: {
          title: 'Indicadores Clave',
          fullTitle: 'Dashboard de Indicadores Clave de Rendimiento',
          shortDescription: 'Inteligencia empresarial y análisis',
          description: 'Monitorea el rendimiento de tu negocio con KPIs en tiempo real y análisis comprensivos para toma de decisiones basada en datos.',
          features: [
            'Dashboard y reportes en tiempo real',
            'Configuración de KPIs a la medida',
            'Inteligencia empresarial y analítica',
            'Análisis de tendencias y pronósticos',
            'Reportes ejecutivos automatizados',
            'Acceso móvil y visualización interactiva'
          ],
          imageSrc: 'https://images.pexels.com/photos/6801874/pexels-photo-6801874.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        }
      }
    },
    industries: {
      automotive: {
        title: 'Automotriz',
        description: 'Soluciones especializadas para fabricantes y proveedores automotrices, optimizando líneas de producción, control de calidad y gestión de cadena de suministro.',
        painPoints: [
          {
            title: 'Cadena de Suministro Compleja',
            description: 'Gestionar múltiples proveedores y asegurar entregas justo a tiempo mientras se mantienen estándares de calidad.'
          },
          {
            title: 'Cumplimiento de Calidad',
            description: 'Cumplir con estrictos estándares de la industria automotriz y requisitos regulatorios en todos los procesos.'
          },
          {
            title: 'Eficiencia de Producción',
            description: 'Optimizar procesos de manufactura para reducir desperdicios y mejorar la efectividad general del equipo.'
          }
        ],
        testimonial: {
          company: 'AutoMex Manufacturing',
          quote: 'LAIMU Trantor nos ayudó a reducir costos de producción en 25% mientras mejoramos métricas de calidad.',
          author: 'Carlos Rodriguez',
          role: 'Director de Operaciones'
        },
        imageSrc: 'https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      manufacturing: {
        title: 'Manufacturera',
        description: 'Soluciones integrales de manufactura para planificación de producción, gestión de inventarios y control de calidad en diversos sectores manufactureros.',
        painPoints: [
          {
            title: 'Planificación de Producción',
            description: 'Coordinar horarios de producción complejos mientras se optimiza la utilización de recursos y se minimiza el tiempo de inactividad.'
          },
          {
            title: 'Gestión de Inventarios',
            description: 'Equilibrar niveles de inventario para satisfacer la demanda mientras se minimizan costos de mantenimiento y desperdicios.'
          },
          {
            title: 'Control de Calidad',
            description: 'Mantener calidad consistente del producto mientras se cumplen objetivos de producción y fechas límite.'
          }
        ],
        testimonial: {
          company: 'TechManufactura',
          quote: 'Nuestra eficiencia de producción aumentó 40% después de implementar LAIMU Trantor.',
          author: 'Ana Martinez',
          role: 'Gerente de Producción'
        },
        imageSrc: 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      accounting: {
        title: 'Contable y Fiscal',
        description: 'Soluciones especializadas para despachos contables y consultorías fiscales, optimizando procesos financieros, cumplimiento y gestión de clientes.',
        painPoints: [
          {
            title: 'Cumplimiento Fiscal',
            description: 'Gestionar regulaciones fiscales complejas y asegurar presentaciones precisas y oportunas para múltiples clientes en diferentes jurisdicciones.'
          },
          {
            title: 'Gestión de Clientes',
            description: 'Organizar datos de clientes, fechas límite y comunicaciones mientras se mantiene confidencialidad y seguridad.'
          },
          {
            title: 'Reportes Financieros',
            description: 'Generar reportes y estados financieros precisos mientras se asegura cumplimiento con estándares contables.'
          }
        ],
        testimonial: {
          company: 'Contadores Asociados',
          quote: 'LAIMU Trantor optimizó nuestros procesos fiscales y mejoró la satisfacción del cliente en 35%.',
          author: 'Miguel Santos',
          role: 'Socio Director'
        },
        imageSrc: 'https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      logistics: {
        title: 'Logística y Distribución',
        description: 'Soluciones logísticas avanzadas para empresas de transporte y centros de distribución, optimizando rutas, gestión de flota y operaciones de entrega.',
        painPoints: [
          {
            title: 'Optimización de Rutas',
            description: 'Planificar rutas de entrega eficientes considerando tráfico, costos de combustible y ventanas de tiempo de clientes.'
          },
          {
            title: 'Gestión de Flota',
            description: 'Monitorear rendimiento de vehículos, horarios de mantenimiento y productividad de conductores en toda la flota.'
          },
          {
            title: 'Seguimiento en Tiempo Real',
            description: 'Proporcionar a clientes actualizaciones precisas de entrega mientras se mantiene visibilidad operacional.'
          }
        ],
        testimonial: {
          company: 'LogiMex Express',
          quote: 'Redujimos tiempos de entrega en 30% y costos de combustible en 20% con LAIMU Trantor.',
          author: 'Sofia Hernandez',
          role: 'Directora de Logística'
        },
        imageSrc: 'https://images.pexels.com/photos/6169668/pexels-photo-6169668.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      },
      printing: {
        title: 'Impresión y Empaques',
        description: 'Soluciones personalizadas para empresas de impresión y empaque, gestionando órdenes complejas, flujos de trabajo de producción y estándares de calidad.',
        painPoints: [
          {
            title: 'Complejidad de Órdenes',
            description: 'Gestionar trabajos de impresión diversos con especificaciones, cantidades y requisitos de entrega variados.'
          },
          {
            title: 'Flujo de Trabajo de Producción',
            description: 'Coordinar operaciones de preprensa, impresión y acabado mientras se mantiene calidad y fechas límite.'
          },
          {
            title: 'Gestión de Materiales',
            description: 'Rastrear papel, tinta y otros materiales mientras se optimiza inventario y se reduce desperdicio.'
          }
        ],
        testimonial: {
          company: 'Imprenta Digital Plus',
          quote: 'Nuestro tiempo de procesamiento de órdenes disminuyó 50% y la satisfacción del cliente mejoró significativamente.',
          author: 'Roberto Jimenez',
          role: 'Gerente de Producción'
        },
        imageSrc: 'https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
      }
    },
    industriesSection: {
      title: 'Industrias que Servimos',
      subtitle: 'Soluciones especializadas adaptadas a las necesidades únicas de tu industria.',
      successStory: 'Historia de Éxito'
    },
    useCases: {
      title: 'Problemas que Resolvemos',
      subtitle: 'Desafíos empresariales reales transformados en ventajas operacionales con Laimu.',
      cases: [
        {
          icon: 'inventory',
          challenge: 'Inventarios Desfasados',
          challengeDescription: 'El seguimiento manual genera discrepancias en stock, exceso de inventario y pérdida de ventas por situaciones de desabasto.',
          solution: 'Control en Tiempo Real con Laimu',
          solutionDescription: 'Seguimiento automático de inventario con visibilidad en tiempo real en todas las ubicaciones, puntos de reorden inteligentes y análisis predictivo.',
          impact: '87%',
          impactLabel: 'Reducción en Discrepancias de Stock'
        },
        {
          icon: 'automation',
          challenge: 'Procesos Manuales Lentos',
          challengeDescription: 'Entrada de datos manual que consume tiempo, trabajo duplicado entre departamentos y errores humanos que retrasan operaciones y aumentan costos.',
          solution: 'Automatización Inteligente de Flujos',
          solutionDescription: 'Automatización de procesos de extremo a extremo con integraciones inteligentes, aprobaciones automáticas y flujo de datos continuo entre departamentos.',
          impact: '65%',
          impactLabel: 'Tiempo Ahorrado en Operaciones'
        },
        {
          icon: 'visibility',
          challenge: 'Falta de Visibilidad Operacional',
          challengeDescription: 'Datos dispersos en múltiples sistemas imposibilitan obtener una imagen clara del rendimiento empresarial en tiempo real.',
          solution: 'Dashboard Unificado con KPIs en Tiempo Real',
          solutionDescription: 'Centro de comando centralizado con métricas en vivo, dashboards personalizables e insights accionables para toma de decisiones más rápida.',
          impact: '3x',
          impactLabel: 'Más Rápida Toma de Decisiones'
        }
      ]
    },
    testimonials: {
      title: 'Lo Que Dicen Nuestros Clientes',
      subtitle: 'Historias reales de empresas que han transformado sus operaciones con LAIMU Trantor.',
      items: [
        {
          quote: 'LAIMU Trantor transformó completamente nuestras operaciones. Vimos un aumento del 45% en eficiencia en los primeros 6 meses.',
          name: 'Maria González',
          role: 'Directora de Operaciones',
          company: 'AutoMex',
          rating: 5,
          metrics: [
            { value: '45%', label: 'Aumento de Eficiencia' },
            { value: '6 meses', label: 'Cronograma de ROI' },
            { value: '25%', label: 'Reducción de Costos' }
          ]
        },
        {
          quote: 'La plataforma integrada eliminó nuestros silos de datos y mejoró la toma de decisiones en todos los departamentos.',
          name: 'Carlos Mendoza',
          role: 'CEO',
          company: 'TechManufactura',
          rating: 5,
          metrics: [
            { value: '80%', label: 'Precisión de Datos' },
            { value: '60%', label: 'Reportes Más Rápidos' },
            { value: '35%', label: 'Mejores Decisiones' }
          ]
        },
        {
          quote: 'Soporte excepcional y una plataforma que crece con nuestro negocio. Altamente recomendado para cualquier empresa manufacturera.',
          name: 'Ana Rodriguez',
          role: 'Gerente de Planta',
          company: 'Industrias del Norte',
          rating: 5,
          metrics: [
            { value: '99.9%', label: 'Tiempo Activo del Sistema' },
            { value: '24/7', label: 'Soporte Disponible' },
            { value: '300%', label: 'Escalabilidad' }
          ]
        }
      ]
    },
    contact: {
      title: 'Comienza Hoy',
      subtitle: '¿Listo para transformar tu negocio? Contacta a nuestros expertos para una consulta personalizada.',
      office: 'Nuestra Oficina',
      phone: 'Teléfono',
      email: 'Correo Electrónico',
      scheduleDemo: 'Agendar una Demo',
      scheduleDemoText: 'Reserva una demostración personalizada',
      scheduleButton: 'Reservar Demo',
      address: {
        line1: 'Pedro Noriega 1751',
        line2: 'Col. Terminal',
        city: 'Monterrey',
        state: 'NL',
        zip: '64580'
      },
      formTitle: 'Envíanos un mensaje',
      form: {
        name: 'Nombre Completo',
        namePlaceholder: 'Tu nombre completo',
        email: 'Correo Electrónico',
        emailPlaceholder: 'tu@email.com',
        company: 'Empresa',
        companyPlaceholder: 'Nombre de tu empresa',
        industry: 'Industria',
        industryPlaceholder: 'Selecciona tu industria',
        message: 'Mensaje',
        messagePlaceholder: 'Cuéntanos sobre tus necesidades...',
        submit: 'Enviar Mensaje',
        other: 'Otro'
      }
    },
    footer: {
      description: 'Transforma tu negocio con nuestra plataforma integral de gestión. Confiado por más de 500 empresas en México y Latinoamérica.',
      solutions: 'Soluciones',
      industries: 'Industrias',
      company: 'Empresa',
      address: 'Pedro Noriega 1751, Col. Terminal, 64580, Monterrey, Nuevo León, México',
      links: [
        { text: 'Nosotros', href: '/about' },
        { text: 'Casos de Éxito', href: '/success-cases' },
        { text: 'Blog', href: '/blog' },
        { text: 'Soporte', href: '/demo' }
      ],
      rights: 'Todos los derechos reservados.',
      privacy: 'Aviso de Privacidad',
      terms: 'Términos y Condiciones',
      cookies: 'Política de Cookies'
    },
    cta: {
      demo: 'Solicitar Demo',
      learnMore: 'Saber Más',
      contact: 'Contactar Ventas',
      industryDemo: 'Ver Demo por Industria',
      caseStudy: 'Ver Casos de Estudio'
    },
    blog: {
      navLabel: 'Blog',
      heroTitle: 'Recursos y Insights',
      heroSubtitle: 'Artículos de expertos sobre ERP, CFDI, manufactura, logística y transformación digital en México.',
      featuredLabel: 'Artículo Destacado',
      readMore: 'Leer Más',
      minutesRead: 'min de lectura',
      allCategories: 'Todos',
      searchPlaceholder: 'Buscar artículos...',
      noResults: 'No se encontraron artículos. Intenta una búsqueda o categoría diferente.',
      backToBlog: 'Volver al Blog',
      shareArticle: 'Comparte este artículo',
      relatedPosts: 'Artículos Relacionados',
      tableOfContents: 'Tabla de Contenidos',
      requestDemoCta: 'Solicita una Demo Gratuita',
      requestDemoText: 'Descubre cómo LAIMU Trantor puede transformar tu empresa. Agenda una demo personalizada sin costo.',
      newsletterTitle: 'Suscríbete a Nuestro Newsletter',
      newsletterSubtitle: 'Recibe los últimos artículos sobre gestión empresarial, tecnología y cumplimiento fiscal en México.',
      newsletterPlaceholder: 'Ingresa tu correo',
      newsletterButton: 'Suscribirme',
      newsletterSuccess: '¡Gracias por suscribirte!',
      newsletterError: 'Algo salió mal. Por favor, inténtalo de nuevo.',
      newsletterDuplicate: 'Este correo ya está suscrito.',
      newsletterPrivacy: 'Acepto recibir comunicaciones de LAIMU.',
      latestInsights: 'Últimos Artículos',
      viewAllPosts: 'Ver Todos los Artículos',
      publishedOn: 'Publicado el',
      by: 'por',
      loadingPosts: 'Cargando artículos...',
      loadMore: 'Cargar Más',
      category: 'Categoría',
      tags: 'Etiquetas'
    },
    successCases: {
      title: 'Historias de Éxito que Inspiran',
      subtitle: 'Descubre cómo empresas de diferentes industrias han transformado sus operaciones y logrado resultados notables con LAIMU Trantor.',
      cases: [
        {
          id: 'automex',
          company: 'AutoMex Manufacturing',
          industry: 'Automotriz',
          employees: '500+ empleados',
          timeline: '6 meses de implementación',
          challenge: 'AutoMex luchaba con sistemas desconectados, procesos manuales y falta de visibilidad en tiempo real en sus operaciones de manufactura. Problemas de control de calidad e ineficiencias en la cadena de suministro impactaban su capacidad de satisfacer demandas de clientes.',
          solution: 'Implementó una solución integral LAIMU Trantor incluyendo módulos de Gestión de Empresas, Producción e Inventarios, y Comercial. La plataforma integrada proporcionó visibilidad en tiempo real y automatizó procesos clave.',
          modules: ['Gestión de Empresas', 'Producción e Inventarios', 'Comercial', 'Indicadores Clave'],
          results: [
            '45% de reducción en costos de producción',
            '80% de mejora en entregas a tiempo',
            '60% más rápido procesamiento de órdenes',
            '300% de aumento en precisión de datos',
            '25% de reducción en costos de mantenimiento de inventario'
          ],
          testimonial: {
            quote: 'LAIMU Trantor transformó toda nuestra operación. La visibilidad en tiempo real y los procesos integrados nos han hecho más competitivos que nunca.',
            author: 'Carlos Rodriguez',
            role: 'Director de Operaciones'
          },
          imageSrc: 'https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        {
          id: 'logimex',
          company: 'LogiMex Express',
          industry: 'Logística y Distribución',
          employees: '200+ empleados',
          timeline: '4 meses de implementación',
          challenge: 'LogiMex enfrentaba desafíos con optimización de rutas, gestión de flota y comunicación con clientes. Los procesos de planificación manual llevaban a costos de combustible aumentados y entregas retrasadas.',
          solution: 'Desplegó el módulo de Transporte y Logística de LAIMU Trantor junto con módulos Comercial e Indicadores Clave para optimizar operaciones y mejorar servicio al cliente.',
          modules: ['Transporte y Logística', 'Comercial', 'Indicadores Clave'],
          results: [
            '30% de reducción en tiempos de entrega',
            '20% de disminución en costos de combustible',
            '90% de mejora en satisfacción del cliente',
            '50% más rápida planificación de rutas',
            '40% de aumento en utilización de flota'
          ],
          testimonial: {
            quote: 'Las capacidades de optimización de rutas y seguimiento en tiempo real han revolucionado nuestras operaciones logísticas.',
            author: 'Sofia Hernandez',
            role: 'Directora de Logística'
          },
          imageSrc: 'https://images.pexels.com/photos/6169668/pexels-photo-6169668.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        },
        {
          id: 'techmanufactura',
          company: 'TechManufactura',
          industry: 'Manufacturera',
          employees: '300+ empleados',
          timeline: '5 meses de implementación',
          challenge: 'TechManufactura necesitaba modernizar sus procesos de manufactura, mejorar control de calidad y obtener mejor visibilidad de sus operaciones para competir en el mercado global.',
          solution: 'Implementó una suite completa LAIMU Trantor incluyendo módulos de Gestión de Empresas, Producción e Inventarios, Gestión del Talento e Indicadores Clave para transformación operacional completa.',
          modules: ['Gestión de Empresas', 'Producción e Inventarios', 'Gestión del Talento', 'Indicadores Clave'],
          results: [
            '40% de aumento en eficiencia de producción',
            '65% de reducción en defectos de calidad',
            '35% de mejora en productividad de empleados',
            '50% más rápidos reportes y análisis',
            '28% de reducción en costos operacionales'
          ],
          testimonial: {
            quote: 'LAIMU Trantor nos dio las herramientas para competir globalmente. Nuestras mejoras en eficiencia y calidad han sido notables.',
            author: 'Ana Martinez',
            role: 'Gerente de Producción'
          },
          imageSrc: 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
        }
      ]
    },
    legal: {
      privacy: {
        title: 'Política de Privacidad',
        lastUpdated: 'Última actualización',
        date: '15 de enero de 2024',
        introduction: {
          title: 'Introducción',
          content: 'LAIMU ("nosotros," "nos," o "nuestro") respeta tu privacidad y está comprometido a proteger tus datos personales. Esta Política de Privacidad te informará sobre cómo cuidamos tus datos personales cuando visitas nuestro sitio web, usas nuestros servicios o interactúas con nosotros, y te dirá sobre tus derechos de privacidad y cómo te protege la ley. Esta Política de Privacidad se aplica a todos los datos personales que procesamos sobre ti.'
        },
        scope: {
          title: 'Alcance de Esta Política',
          content: 'Esta Política de Privacidad se aplica a los datos personales recopilados por LAIMU a través de nuestros sitios web, aplicaciones móviles, ofertas de software como servicio y otras interacciones en línea y fuera de línea contigo. Cubre datos recopilados directamente de ti, datos que recibimos de terceros y datos que generamos sobre tu uso de nuestros servicios.',
          exclusions: 'Esta política no se aplica a: (a) datos procesados por nuestros clientes usando nuestros servicios, (b) sitios web o servicios de terceros enlazados desde nuestros sitios, o (c) datos relacionados con el empleo de nuestros empleados y contratistas.'
        },
        controller: {
          title: 'Controlador de Datos',
          content: 'LAIMU es el controlador de datos para los datos personales que procesamos bajo esta Política de Privacidad. Nuestros datos de contacto se proporcionan al final de esta política.'
        },
        dataCollection: {
          title: 'Datos Personales que Recopilamos',
          intro: 'Recopilamos diferentes tipos de datos personales sobre ti. Esto incluye datos que nos das directamente, datos que recopilamos automáticamente y datos que recibimos de terceros.',
          categories: {
            identity: {
              title: 'Datos de Identidad',
              items: ['Nombre, apellido, nombre de usuario, título, fecha de nacimiento, género']
            },
            contact: {
              title: 'Datos de Contacto',
              items: ['Dirección de email, números de teléfono, dirección de facturación, dirección de entrega']
            },
            financial: {
              title: 'Datos Financieros',
              items: ['Detalles de cuenta bancaria, detalles de tarjeta de pago, historial de transacciones']
            },
            technical: {
              title: 'Datos Técnicos',
              items: ['Dirección de protocolo de internet (IP), tipo y versión del navegador, configuración de zona horaria, tipos de complementos del navegador, sistema operativo y plataforma, información del dispositivo']
            },
            profile: {
              title: 'Datos de Perfil',
              items: ['Nombre de usuario, contraseña, compras, pedidos, intereses, preferencias, comentarios, respuestas de encuestas']
            },
            usage: {
              title: 'Datos de Uso',
              items: ['Información sobre cómo usas nuestro sitio web, productos y servicios, incluyendo frecuencia de uso, uso de características, datos de rendimiento']
            },
            marketing: {
              title: 'Datos de Marketing y Comunicaciones',
              items: ['Tus preferencias para recibir marketing de nosotros y nuestros terceros, preferencias de comunicación']
            }
          },
          sources: {
            title: 'Cómo Recopilamos Datos Personales',
            direct: {
              title: 'Interacciones Directas',
              content: 'Puedes darnos tus datos personales completando formularios o correspondiendo con nosotros por correo, teléfono, email o de otra manera. Esto incluye datos personales que proporcionas cuando:',
              examples: ['Solicitas nuestros productos o servicios', 'Creas una cuenta en nuestro sitio web', 'Te suscribes a nuestro servicio o publicaciones', 'Solicitas que te enviemos marketing', 'Participas en una competencia, promoción o encuesta', 'Nos das comentarios o nos contactas']
            },
            automated: {
              title: 'Tecnologías Automatizadas o Interacciones',
              content: 'Mientras interactúas con nuestro sitio web, recopilaremos automáticamente Datos Técnicos sobre tu equipo, acciones de navegación y patrones. Recopilamos estos datos personales usando cookies, registros del servidor y otras tecnologías similares.'
            },
            thirdParties: {
              title: 'Terceros o Fuentes Públicamente Disponibles',
              content: 'Recibiremos datos personales sobre ti de varios terceros y fuentes públicas como se establece a continuación:',
              sources: ['Datos Técnicos de proveedores de analítica como Google', 'Datos de Contacto, Financieros y de Transacciones de proveedores de servicios técnicos, de pago y entrega', 'Datos de Identidad y Contacto de intermediarios o agregadores de datos', 'Datos de Identidad y Contacto de fuentes públicamente disponibles']
            }
          }
        },
        legalBasis: {
          title: 'Base Legal para el Procesamiento',
          intro: 'Solo usaremos tus datos personales cuando la ley nos lo permita. Más comúnmente, usaremos tus datos personales en las siguientes circunstancias:',
          bases: {
            consent: {
              title: 'Consentimiento',
              content: 'Donde has dado consentimiento claro para que procesemos tus datos personales para un propósito específico.'
            },
            contract: {
              title: 'Contrato',
              content: 'Donde necesitamos cumplir el contrato que estamos a punto de celebrar o hemos celebrado contigo.'
            },
            legal: {
              title: 'Obligación Legal',
              content: 'Donde necesitamos cumplir con una obligación legal.'
            },
            vital: {
              title: 'Intereses Vitales',
              content: 'Donde es necesario para proteger la vida de alguien.'
            },
            public: {
              title: 'Tarea Pública',
              content: 'Donde necesitamos realizar una tarea de interés público o para nuestras funciones oficiales.'
            },
            legitimate: {
              title: 'Intereses Legítimos',
              content: 'Donde necesitamos para nuestros intereses legítimos (o los de un tercero) y tus intereses y derechos fundamentales no anulan esos intereses.'
            }
          }
        },
        dataUse: {
          title: 'Cómo Usamos Tus Datos Personales',
          intro: 'Hemos establecido a continuación, en formato de tabla, una descripción de todas las formas en que planeamos usar tus datos personales, y en cuáles de las bases legales nos basamos para hacerlo. También hemos identificado cuáles son nuestros intereses legítimos cuando sea apropiado.',
          purposes: {
            registration: {
              purpose: 'Para registrarte como nuevo cliente',
              dataTypes: 'Identidad, Contacto',
              legalBasis: 'Cumplimiento de un contrato contigo'
            },
            services: {
              purpose: 'Para procesar y entregar tu pedido incluyendo gestionar pagos, tarifas y cargos, y cobrar y recuperar dinero que se nos debe',
              dataTypes: 'Identidad, Contacto, Financiero, Transacción, Marketing y Comunicaciones',
              legalBasis: 'Cumplimiento de un contrato contigo; Necesario para nuestros intereses legítimos (recuperar deudas que se nos deben)'
            },
            relationship: {
              purpose: 'Para gestionar nuestra relación contigo incluyendo notificarte sobre cambios en nuestros términos o política de privacidad, y pedirte que dejes una reseña o hagas una encuesta',
              dataTypes: 'Identidad, Contacto, Perfil, Marketing y Comunicaciones',
              legalBasis: 'Cumplimiento de un contrato contigo; Necesario para cumplir con una obligación legal; Necesario para nuestros intereses legítimos (mantener nuestros registros actualizados y estudiar cómo los clientes usan nuestros productos/servicios)'
            },
            administration: {
              purpose: 'Para permitirte participar en un sorteo, competencia o completar una encuesta',
              dataTypes: 'Identidad, Contacto, Perfil, Uso, Marketing y Comunicaciones',
              legalBasis: 'Necesario para nuestros intereses legítimos (estudiar cómo los clientes usan nuestros productos/servicios, desarrollarlos y hacer crecer nuestro negocio)'
            },
            business: {
              purpose: 'Para administrar y proteger nuestro negocio y este sitio web (incluyendo solución de problemas, análisis de datos, pruebas, mantenimiento del sistema, soporte, informes y alojamiento de datos)',
              dataTypes: 'Identidad, Contacto, Técnico',
              legalBasis: 'Necesario para nuestros intereses legítimos (para operar nuestro negocio, provisión de servicios de administración y TI, seguridad de red, prevenir fraude y en el contexto de una reorganización empresarial o ejercicio de reestructuración de grupo); Necesario para cumplir con una obligación legal'
            },
            content: {
              purpose: 'Para entregarte contenido relevante del sitio web y anuncios y medir o entender la efectividad de la publicidad que te servimos',
              dataTypes: 'Identidad, Contacto, Perfil, Uso, Marketing y Comunicaciones, Técnico',
              legalBasis: 'Necesario para nuestros intereses legítimos (estudiar cómo los clientes usan nuestros productos/servicios, desarrollarlos, hacer crecer nuestro negocio e informar nuestra estrategia de marketing)'
            },
            analytics: {
              purpose: 'Para usar analítica de datos para mejorar nuestro sitio web, productos/servicios, marketing, relaciones con clientes y experiencias',
              dataTypes: 'Técnico, Uso',
              legalBasis: 'Necesario para nuestros intereses legítimos (definir tipos de clientes para nuestros productos y servicios, mantener nuestro sitio web actualizado y relevante, desarrollar nuestro negocio e informar nuestra estrategia de marketing)'
            },
            recommendations: {
              purpose: 'Para hacerte sugerencias y recomendaciones sobre bienes o servicios que puedan interesarte',
              dataTypes: 'Identidad, Contacto, Técnico, Uso, Perfil, Marketing y Comunicaciones',
              legalBasis: 'Necesario para nuestros intereses legítimos (desarrollar nuestros productos/servicios y hacer crecer nuestro negocio)'
            }
          },
          marketing: {
            title: 'Marketing',
            content: 'Nos esforzamos por proporcionarte opciones con respecto a ciertos usos de datos personales, particularmente alrededor del marketing y publicidad. Puedes ver y tomar ciertas decisiones sobre el uso de tus datos personales en la configuración de tu cuenta.'
          }
        },
        sharing: {
          title: 'Divulgaciones de Tus Datos Personales',
          intro: 'Podemos tener que compartir tus datos personales con las partes establecidas a continuación para los propósitos establecidos en la tabla anterior.',
          categories: {
            internal: {
              title: 'Terceros Internos',
              content: 'Otras empresas en el Grupo LAIMU que actúan como controladores conjuntos o procesadores y que están basadas en México y proporcionan servicios de TI y administración de sistemas y realizan informes de liderazgo.'
            },
            external: {
              title: 'Terceros Externos',
              items: [
                'Proveedores de servicios que actúan como procesadores que proporcionan servicios de TI y administración de sistemas',
                'Asesores profesionales que actúan como procesadores o controladores conjuntos incluyendo abogados, banqueros, auditores y aseguradoras que proporcionan servicios de consultoría, bancarios, legales, de seguros y contabilidad',
                'Autoridades fiscales, reguladores y otras autoridades que actúan como procesadores o controladores conjuntos basados en México que requieren informes de actividades de procesamiento en ciertas circunstancias'
              ]
            },
            specific: {
              title: 'Terceros Específicos',
              items: [
                'Proveedores de analítica como Google Analytics',
                'Redes publicitarias y plataformas de redes sociales',
                'Procesadores de pagos e instituciones financieras',
                'Plataformas de soporte al cliente y comunicación',
                'Proveedores de alojamiento en la nube e infraestructura',
                'Servicios de seguridad y prevención de fraude'
              ]
            }
          },
          circumstances: {
            title: 'También podemos compartir tus datos personales en las siguientes circunstancias:',
            items: [
              'Transferencias comerciales: En conexión con cualquier fusión, venta de activos, financiamiento o adquisición de todo o parte de nuestro negocio',
              'Requisitos legales: Cuando sea requerido por ley, regulación, proceso legal o solicitud gubernamental',
              'Seguridad y protección: Para proteger los derechos, propiedad o seguridad de LAIMU, nuestros usuarios u otros',
              'Consentimiento: Cuando nos hayas dado consentimiento explícito para compartir tu información',
              'Información pública: Información que haces públicamente disponible',
              'Datos agregados: Información desidentificada o agregada que no puede identificarte razonablemente'
            ]
          }
        },
        internationalTransfers: {
          title: 'Transferencias Internacionales',
          content: 'Podemos transferir tus datos personales fuera de México. Siempre que transferimos tus datos personales fuera de México, aseguramos que se le otorgue un grado similar de protección asegurando que al menos una de las siguientes salvaguardas esté implementada:',
          safeguards: [
            'Solo transferiremos tus datos personales a países que se haya considerado que proporcionan un nivel adecuado de protección para datos personales',
            'Donde usamos ciertos proveedores de servicios, podemos usar contratos específicos aprobados por autoridades regulatorias que dan a los datos personales la misma protección que tiene en México',
            'Donde usamos proveedores basados en EE.UU., podemos transferir datos a ellos si son parte del Privacy Shield que les requiere proporcionar protección similar a los datos personales compartidos entre México y EE.UU.'
          ]
        },
        dataSecurity: {
          title: 'Seguridad de Datos',
          content: 'Hemos implementado medidas de seguridad apropiadas para prevenir que tus datos personales se pierdan accidentalmente, se usen o accedan de manera no autorizada, se alteren o divulguen. Además, limitamos el acceso a tus datos personales a aquellos empleados, agentes, contratistas y otros terceros que tienen una necesidad comercial de saber.',
          measures: [
            'Encriptación estándar de la industria para datos en tránsito y en reposo',
            'Autenticación multifactor para acceso al sistema',
            'Auditorías de seguridad regulares y pruebas de penetración',
            'Entrenamiento de empleados en protección de datos y seguridad',
            'Procedimientos de respuesta a incidentes para violaciones de datos',
            'Controles de seguridad física para nuestras instalaciones',
            'Monitoreo de seguridad de red y detección de intrusiones',
            'Actualizaciones regulares de software y parches de seguridad',
            'Procedimientos de respaldo de datos y recuperación ante desastres'
          ],
          breach: 'Tenemos procedimientos implementados para lidiar con cualquier sospecha de violación de datos personales y te notificaremos a ti y a cualquier regulador aplicable de una violación donde estemos legalmente requeridos a hacerlo.'
        },
        retention: {
          title: 'Retención de Datos',
          intro: 'Solo retendremos tus datos personales por el tiempo que sea razonablemente necesario para cumplir los propósitos para los que los recopilamos, incluyendo para los propósitos de satisfacer cualquier requisito legal, regulatorio, fiscal, contable o de informes.',
          criteria: 'Para determinar el período de retención apropiado para datos personales, consideramos la cantidad, naturaleza y sensibilidad de los datos personales, el riesgo potencial de daño por uso no autorizado o divulgación de tus datos personales, los propósitos para los cuales procesamos tus datos personales y si podemos lograr esos propósitos a través de otros medios, y los requisitos legales, regulatorios, fiscales, contables u otros aplicables.',
          periods: {
            account: {
              type: 'Datos de Cuenta',
              period: 'Por la duración de tu cuenta más 7 años después del cierre de cuenta'
            },
            transaction: {
              type: 'Registros de Transacciones',
              period: '10 años desde la fecha de transacción para propósitos fiscales y contables'
            },
            communication: {
              type: 'Datos de Comunicación',
              period: '3 años desde la última comunicación para propósitos de servicio al cliente'
            },
            usage: {
              type: 'Datos de Uso y Analítica',
              period: '2 años desde la recopilación para propósitos de mejora del negocio'
            },
            marketing: {
              type: 'Datos de Marketing',
              period: 'Hasta que retires el consentimiento o te excluyas de las comunicaciones de marketing'
            }
          }
        },
        rights: {
          title: 'Tus Derechos Legales',
          intro: 'Bajo ciertas circunstancias, tienes derechos bajo las leyes de protección de datos en relación con tus datos personales. Tienes derecho a:',
          list: {
            access: {
              title: 'Solicitar acceso',
              description: 'a tus datos personales (comúnmente conocido como "solicitud de acceso del sujeto de datos"). Esto te permite recibir una copia de los datos personales que tenemos sobre ti y verificar que los estamos procesando legalmente.'
            },
            correction: {
              title: 'Solicitar corrección',
              description: 'de los datos personales que tenemos sobre ti. Esto te permite hacer que cualquier dato incompleto o inexacto que tenemos sobre ti sea corregido, aunque podemos necesitar verificar la precisión de los nuevos datos que nos proporciones.'
            },
            erasure: {
              title: 'Solicitar eliminación',
              description: 'de tus datos personales. Esto te permite pedirnos que eliminemos o removamos datos personales donde no hay una buena razón para que continuemos procesándolos. También tienes derecho a pedirnos que eliminemos o removamos tus datos personales donde has ejercido exitosamente tu derecho a objetar el procesamiento, donde podemos haber procesado tu información ilegalmente o donde se nos requiere borrar tus datos personales para cumplir con la ley local.'
            },
            objection: {
              title: 'Objetar el procesamiento',
              description: 'de tus datos personales donde nos basamos en un interés legítimo (o los de un tercero) y hay algo sobre tu situación particular que te hace querer objetar el procesamiento en esta base ya que sientes que impacta en tus derechos y libertades fundamentales. También tienes derecho a objetar donde estamos procesando tus datos personales para propósitos de marketing directo.'
            },
            restriction: {
              title: 'Solicitar restricción',
              description: 'del procesamiento de tus datos personales. Esto te permite pedirnos que suspendamos el procesamiento de tus datos personales en los siguientes escenarios: si quieres que establezcamos la precisión de los datos; donde nuestro uso de los datos es ilegal pero no quieres que los borremos; donde necesitas que mantengamos los datos incluso si ya no los requerimos ya que los necesitas para establecer, ejercer o defender reclamos legales; o has objetado nuestro uso de tus datos pero necesitamos verificar si tenemos bases legítimas prevalecientes para usarlos.'
            },
            portability: {
              title: 'Solicitar transferencia',
              description: 'de tus datos personales a ti o a un tercero. Te proporcionaremos, o a un tercero que hayas elegido, tus datos personales en un formato estructurado, comúnmente usado, legible por máquina. Nota que este derecho solo se aplica a información automatizada para la cual inicialmente proporcionaste consentimiento para que usáramos o donde usamos la información para realizar un contrato contigo.'
            },
            withdraw: {
              title: 'Retirar consentimiento',
              description: 'en cualquier momento donde nos basamos en consentimiento para procesar tus datos personales. Sin embargo, esto no afectará la legalidad de cualquier procesamiento realizado antes de que retires tu consentimiento. Si retiras tu consentimiento, podemos no ser capaces de proporcionarte ciertos productos o servicios. Te avisaremos si este es el caso en el momento que retires tu consentimiento.'
            }
          },
          exercise: {
            title: 'Cómo Ejercer Tus Derechos',
            content: 'Si deseas ejercer cualquiera de los derechos establecidos arriba, por favor contáctanos usando los detalles proporcionados al final de esta política. No tendrás que pagar una tarifa para acceder a tus datos personales (o para ejercer cualquiera de los otros derechos). Sin embargo, podemos cobrar una tarifa razonable si tu solicitud es claramente infundada, repetitiva o excesiva. Alternativamente, podríamos negarnos a cumplir con tu solicitud en estas circunstancias.',
            verification: 'Podemos necesitar solicitar información específica de ti para ayudarnos a confirmar tu identidad y asegurar tu derecho a acceder a tus datos personales (o para ejercer cualquiera de tus otros derechos). Esta es una medida de seguridad para asegurar que los datos personales no se divulguen a ninguna persona que no tenga derecho a recibirlos. También podemos contactarte para pedirte más información en relación con tu solicitud para acelerar nuestra respuesta.',
            timeframe: 'Tratamos de responder a todas las solicitudes legítimas dentro de un mes. Ocasionalmente podría tomarnos más de un mes si tu solicitud es particularmente compleja o has hecho varias solicitudes. En este caso, te notificaremos y te mantendremos actualizado.'
          }
        },
        minors: {
          title: 'Privacidad de Menores',
          content: 'Nuestros servicios no están destinados para niños menores de 16 años. No recopilamos conscientemente datos personales de niños menores de 16. Si eres menor de 16, no uses o proporciones ninguna información en nuestro sitio web o a través de nuestros servicios. Si nos enteramos de que hemos recopilado o recibido datos personales de un niño menor de 16 sin verificación del consentimiento parental, eliminaremos esa información. Si crees que podríamos tener alguna información de o sobre un niño menor de 16, por favor contáctanos.'
        },
        thirdPartyLinks: {
          title: 'Enlaces de Terceros',
          content: 'Este sitio web puede incluir enlaces a sitios web de terceros, complementos y aplicaciones. Hacer clic en esos enlaces o habilitar esas conexiones puede permitir a terceros recopilar o compartir datos sobre ti. No controlamos estos sitios web de terceros y no somos responsables de sus declaraciones de privacidad. Cuando dejes nuestro sitio web, te alentamos a leer la política de privacidad de cada sitio web que visites.'
        },
        updates: {
          title: 'Cambios a Esta Política de Privacidad',
          content: 'Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos de cualquier cambio publicando la nueva Política de Privacidad en esta página y actualizando la fecha de "última actualización". Se te aconseja revisar esta Política de Privacidad periódicamente para cualquier cambio. Los cambios a esta Política de Privacidad son efectivos cuando se publican en esta página.',
          notification: 'Si hacemos cambios materiales a cómo tratamos los datos personales de nuestros usuarios, te notificaremos a través de un aviso en la página de inicio del sitio web o por email a la dirección de email principal especificada en tu cuenta.'
        },
        complaints: {
          title: 'Quejas',
          content: 'Tienes derecho a presentar una queja en cualquier momento a la autoridad supervisora relevante para asuntos de protección de datos. Sin embargo, apreciaríamos la oportunidad de lidiar con tus preocupaciones antes de que te acerques a la autoridad supervisora, así que por favor contáctanos en primera instancia.',
          authorities: {
            mexico: 'México: Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI)',
            eu: 'UE: Tu autoridad local de protección de datos',
            us: 'EE.UU.: Comisión Federal de Comercio (FTC) o tu fiscal general estatal'
          }
        },
        contact: {
          title: 'Información de Contacto',
          content: 'Si tienes alguna pregunta sobre esta Política de Privacidad o nuestras prácticas de privacidad, por favor contáctanos usando la información a continuación:',
          details: {
            company: 'LAIMU',
            dpo: 'Oficial de Protección de Datos',
            email: 'privacy@laimu.mx',
            phone: '+52 81 1107 1450',
            address: 'Pedro Noriega 1751, Monterrey, NL 64580, México',
            hours: 'Lunes a Viernes, 9:00 AM a 6:00 PM (CST)'
          },
          response: 'Responderemos a tu consulta dentro de 30 días de recibida. Para asuntos urgentes de privacidad, por favor llama a nuestro número principal y pide hablar con nuestro Oficial de Protección de Datos.'
        }
      },
      terms: {
        title: 'Términos de Servicio',
        lastUpdated: 'Última actualización',
        date: '15 de enero de 2024',
        acceptance: {
          title: 'Aceptación de Términos',
          content: 'Al acceder y usar los servicios de LAIMU Trantor, aceptas y acuerdas estar sujeto a los términos y disposiciones de este acuerdo.'
        },
        services: {
          title: 'Descripción de Servicios',
          intro: 'LAIMU proporciona soluciones de software de gestión empresarial incluyendo:',
          list: [
            'Sistemas de Planificación de Recursos Empresariales (ERP)',
            'Herramientas de Gestión de Relaciones con Clientes (CRM)',
            'Sistemas de Gestión de Transporte (TMS)',
            'Soluciones de Planificación de Recursos de Manufactura (MRP)',
            'Sistemas de Gestión de Recursos Humanos (HRMS)',
            'Dashboards de Indicadores Clave de Rendimiento (KPI)'
          ]
        },
        userResponsibilities: {
          title: 'Responsabilidades del Usuario',
          intro: 'Como usuario de nuestros servicios, acuerdas:',
          list: [
            'Proporcionar información precisa y completa',
            'Mantener la seguridad de las credenciales de tu cuenta',
            'Usar los servicios en cumplimiento con las leyes aplicables',
            'No intentar violar la seguridad del sistema',
            'Respetar los derechos de propiedad intelectual'
          ]
        },
        payment: {
          title: 'Términos de Pago',
          content: 'Los términos de pago se especifican en tu acuerdo de servicio. Todas las tarifas no son reembolsables a menos que se indique lo contrario. Nos reservamos el derecho de modificar precios con aviso apropiado.'
        },
        liability: {
          title: 'Limitación de Responsabilidad',
          content: 'LAIMU no será responsable por daños indirectos, incidentales, especiales o consecuentes que surjan del uso de nuestros servicios, excepto según lo requerido por la ley aplicable.'
        },
        termination: {
          title: 'Terminación',
          content: 'Cualquier parte puede terminar el acuerdo de servicio con aviso apropiado según se especifica en tu contrato. Al terminar, el acceso a los servicios será discontinuado.'
        },
        changes: {
          title: 'Cambios a los Términos',
          content: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. Los usuarios serán notificados de cambios significativos, y el uso continuado constituye aceptación de los términos modificados.'
        },
        contact: {
          title: 'Información de Contacto',
          content: 'Para preguntas sobre estos Términos de Servicio, por favor contáctanos:'
        }
      },
      cookies: {
        title: 'Política de Cookies',
        lastUpdated: 'Última actualización',
        date: '15 de enero de 2024',
        what: {
          title: 'Qué Son las Cookies',
          content: 'Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas nuestro sitio web. Nos ayudan a proporcionarte una mejor experiencia recordando tus preferencias y analizando cómo usas nuestro sitio.'
        },
        types: {
          title: 'Tipos de Cookies que Usamos',
          intro: 'Usamos diferentes tipos de cookies para varios propósitos:',
          essential: {
            title: 'Cookies Esenciales',
            description: 'Estas cookies son necesarias para que el sitio web funcione correctamente y no pueden ser deshabilitadas.'
          },
          analytics: {
            title: 'Cookies de Análisis',
            description: 'Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web recopilando información anónima.'
          },
          functional: {
            title: 'Cookies Funcionales',
            description: 'Estas cookies habilitan funcionalidad mejorada y personalización, como preferencias de idioma.'
          },
          marketing: {
            title: 'Cookies de Marketing',
            description: 'Estas cookies se usan para entregar anuncios relevantes y rastrear la efectividad de nuestras campañas de marketing.'
          }
        },
        thirdParty: {
          title: 'Cookies de Terceros',
          intro: 'Podemos usar servicios de terceros que establecen cookies en nuestro nombre:',
          services: [
            'Google Analytics para análisis del sitio web',
            'Plataformas de redes sociales para compartir contenido',
            'Servicios de chat de soporte al cliente',
            'Plataformas de marketing y publicidad'
          ]
        },
        control: {
          title: 'Gestión de Cookies',
          intro: 'Puedes controlar las cookies a través de:',
          methods: [
            'Configuraciones del navegador para bloquear o eliminar cookies',
            'Nuestro centro de preferencias de cookies',
            'Herramientas de exclusión de terceros',
            'Configuraciones de privacidad en tu dispositivo'
          ],
          warning: {
            title: 'Nota Importante',
            content: 'Deshabilitar ciertas cookies puede afectar la funcionalidad de nuestro sitio web y tu experiencia de usuario.'
          }
        },
        updates: {
          title: 'Actualizaciones a Esta Política',
          content: 'Podemos actualizar esta Política de Cookies de vez en cuando. Cualquier cambio será publicado en esta página con una fecha de revisión actualizada.'
        },
        contact: {
          title: 'Contáctanos',
          content: 'Si tienes preguntas sobre nuestro uso de cookies, por favor contáctanos:'
        }
      }
    }
  }
};